define(["require", "exports", "knockout", "../../utils/kendoUtils", "../../models/UserContext", "../helpscout/helpscoutActions", "../../models/CustomerModel"], function (require, exports, ko, KendoUtils, UserContext, HelpScoutActions, CustomerModel) {
    "use strict";
    var CustomerTickets = /** @class */ (function () {
        function CustomerTickets(editModel, lookupLists, initGridCallback) {
            this.userCanViewHelpScout = ko.observable(UserContext.hasAccess("Admin,HelpScout.View,HelpScout.Edit,HelpScout.Delete"));
            this.userCanEditHelpScout = ko.observable(UserContext.hasAccess("Admin,HelpScout.Edit,HelpScout.Delete"));
            this.userCanDeleteHelpScout = ko.observable(UserContext.hasAccess("Admin,HelpScout.Delete"));
            this.filterByHelpScoutStatus = ko.observable("");
            this.filterByHelpScoutPeriod = ko.observable("60");
            this.expandedHelpScoutThreadIDs = [];
            this.helpScoutUsers = ko.observableArray([]);
            this.isLookupDataLoaded = false;
            this.isInitGridRequested = false;
            this.editModel = ko.observable(new CustomerModel());
            var self = this;
            self.helpScoutActions = new HelpScoutActions();
            self.editModel = editModel;
            self.lookupLists = lookupLists;
            self.isLookupDataLoaded = false;
            self.helpScoutConversationGridStructure = lookupLists.GridStructures.HelpScoutConversationsStructure;
            if (self.userCanViewHelpScout()) {
                self.initExportDataSource();
                if (initGridCallback) {
                    initGridCallback(self);
                }
            }
        }
        CustomerTickets.prototype.initGrid = function () {
            if (this.userCanViewHelpScout()) {
                this.initHelpScoutConversations();
                ko.applyBindings(this, document.getElementById("divHelpScoutTable"));
                /*this.helpScoutActions.saveCallback = () => {
                    this.customerFirewallTable.refresh();
                };
    
                this.firewallActions.deleteCallback = () => {
                    this.customerFirewallTable.refresh();
                };*/
            }
        };
        CustomerTickets.prototype.editHelpScoutConversation = function (conversationId) {
            var self = this;
            self.helpScoutActions.editHelpScoutConversation(conversationId, self.helpScoutConversationTable, self.editModel().Id());
        };
        CustomerTickets.prototype.initExportDataSource = function () {
            var self = this;
            self.helpScoutConversationDataSourceOptions = {
                transport: {
                    read: {
                        url: "/Support/GetHelpScoutConversations",
                        type: "POST",
                        data: function () {
                            var data = {
                                customerId: self.editModel().Id(),
                                periodFilter: self.filterByHelpScoutPeriod(),
                                statusFilter: self.filterByHelpScoutStatus()
                            };
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.helpScoutConversationGridStructure.model
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.helpScoutConversationDataSource = new kendo.data.DataSource(self.helpScoutConversationDataSourceOptions);
        };
        CustomerTickets.prototype.initHelpScoutMenu = function () {
            var self = this;
            setTimeout(function () {
                var element = document.getElementById("divHelpScoutTable");
                $("#menu", element).kendoMenu();
                // get a reference to the menu widget
                var menu = $("#menu", element).data("kendoMenu");
                // bind to the select event
                menu.bind("select", function (e) {
                    // handle event
                    var actionName = $(e.item).data("action");
                    if (actionName) {
                        self[actionName]();
                    }
                });
            });
        };
        CustomerTickets.prototype.initHelpScoutConversations = function () {
            var self = this;
            var gridId = "divHelpScoutTable";
            var gridStructure = self.lookupLists.GridStructures.HelpScoutConversationsStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "160px",
                sortable: false,
                template: function (dataItem) {
                    var html = '<div class="text-center">';
                    if (self.userCanEditHelpScout()) {
                        html += '<a class="btn btn-sm btn-default btn-hs-t-reply" href="#" title="Reply"><i class="fa fa-reply"></i></a>';
                        html += '&nbsp;<a class="btn btn-sm btn-warning btn-hs-t-note" href="#" title="Add Note"><i class="fa fa-sticky-note-o"></i></a>';
                        html += '&nbsp;<a class="btn btn-sm btn-info btn-hs-c-edit" href="#" title="Edit"><i class="fa fa-edit"></i></a>';
                        if (dataItem.Tags != null && (dataItem.Tags.indexOf(self.editModel().AccountNumber() + "") > -1)) {
                            html += '&nbsp;<a class="btn btn-sm btn-warning btn-hs-c-unlink" title="Unlink" href="#"><i class="fa fa-unlink"></i></a>';
                        }
                        else {
                            html += '&nbsp;<a class="btn btn-sm btn-warning btn-hs-c-link" title="Link" href="#"><i class="fa fa-link"></i></a>';
                        }
                    }
                    html += "</div>";
                    return html;
                }
            });
            self.helpScoutConversationTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Support/GetHelpScoutConversations",
                            type: "POST",
                            data: function () {
                                var data = {
                                    customerId: self.editModel().Id(),
                                    periodFilter: self.filterByHelpScoutPeriod(),
                                    statusFilter: self.filterByHelpScoutStatus()
                                };
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverSorting: false,
                    schema: {
                        model: gridStructure.model
                    },
                    pageSize: 50
                },
                gridOptions: {
                    toolbar: kendo.template($("#helpscout-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    detailInit: self.initHelpScoutThreads.bind(self),
                    dataBound: function (e) {
                        var gridData = e.sender;
                        $.each(gridData.tbody.find("tr.k-master-row"), function () {
                            var rowData = gridData.dataItem(this);
                            if (self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                                gridData.expandRow(this);
                            }
                        });
                        var tooltip = $(gridData.tbody.find("tr.k-master-row .btn")).kendoTooltip({
                            position: "top"
                        }).data("kendoTooltip");
                    },
                    detailExpand: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        if (!self.contains(self.expandedHelpScoutThreadIDs, rowData.Id)) {
                            self.expandedHelpScoutThreadIDs.push(rowData.Id);
                        }
                    },
                    detailCollapse: function (e) {
                        var rowData = e.sender.dataItem(e.masterRow);
                        for (var i = 0; i < self.expandedHelpScoutThreadIDs.length; i++) {
                            if (self.expandedHelpScoutThreadIDs[i] == rowData.Id)
                                self.expandedHelpScoutThreadIDs.splice(i, 1);
                        }
                    },
                    pageable: {
                        refresh: true,
                        pageSizes: [10, 25, 50],
                        buttonCount: 5
                    }
                },
                gridId: gridId,
                showPagerOnTop: true
            };
            self.helpScoutConversationTable.initGrid(gridOptions);
            $("#" + gridId + " tbody").on("click", ".btn-hs-t-reply", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.helpScoutActions.editHelpScoutThread(data.Id, data.Subject, data.OwnerId, self.helpScoutConversationTable);
                event.preventDefault();
            }).on("click", ".btn-hs-t-note", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.helpScoutActions.editHelpScoutThread(data.Id, data.Subject, data.OwnerId, self.helpScoutConversationTable, "Note");
                event.preventDefault();
            }).on("click", ".btn-hs-c-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editHelpScoutConversation(data.Id);
                event.preventDefault();
            }).on("click", ".btn-hs-c-link", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.helpScoutActions.linkHelpScoutConversation(data.Id, self.editModel().Id(), self.editModel().AccountNumber(), self.helpScoutConversationTable);
                event.preventDefault();
            }).on("click", ".btn-hs-c-unlink", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.helpScoutActions.linkHelpScoutConversation(data.Id, 0, 0, self.helpScoutConversationTable);
                event.preventDefault();
            });
            self.filterByHelpScoutStatus.extend({ rateLimit: 200 }).subscribe(function () {
                self.helpScoutConversationTable.getGridData().dataSource.read();
            });
            self.filterByHelpScoutPeriod.extend({ rateLimit: 200 }).subscribe(function () {
                self.helpScoutConversationTable.getGridData().dataSource.read();
            });
        };
        CustomerTickets.prototype.initHelpScoutThreads = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.HelpScoutThreadStructure;
            var grid = $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    transport: {
                        read: {
                            url: "/Support/GetHelpScoutConversationThreads",
                            type: "POST",
                            data: function () {
                                var data = {
                                    conversationId: e.data.Id
                                };
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    }
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                pageable: false,
                columns: [{
                        field: "",
                        template: $("#thread-template").html()
                    }],
                dataBound: function (event) {
                    var items = event.sender.dataItems();
                    if (items && items.length > 0) {
                        var firstItem = items[0];
                        e.data["OwnerName"] = firstItem.AssignToName;
                        e.data["OwnerId"] = firstItem.AssignToId;
                        self.helpScoutConversationTable.redrawRow(e.masterRow);
                        $(".thead-date").kendoTooltip({
                            position: "right"
                        });
                    }
                },
            }).data("kendoGrid");
            $(".k-grid tbody .k-grid .k-grid-header").hide();
        };
        CustomerTickets.prototype.initHelpScoutThreadColumns = function () {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.HelpScoutThreadStructure;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = '<div class="text-center">';
                    html += '<a class="btn btn-sm btn-info btn-hs-t-edit" href="#"><i class="fa fa-edit "></i>&nbsp;Edit</a>';
                    html += "</div>";
                    return html;
                }
            });
        };
        CustomerTickets.prototype.contains = function (a, obj) {
            for (var i = 0; i < a.length; i++) {
                if (a[i] === obj)
                    return true;
            }
            return false;
        };
        return CustomerTickets;
    }());
    return CustomerTickets;
});
//# sourceMappingURL=customerTickets.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerTickets.js
// module id = 206
// module chunks = 2